import { render } from "./modify-button.vue?vue&type=template&id=6597c3fd"
const script = {}

import "./modify-button.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__